export default "__VITE_ASSET__2QmsZUvk__"